module.exports = "/shiftTasks/components/taskInstances/taskInstances-3e9d4d.html";